export default __webpack_public_path__ + "static/media/airstrapz-blk-1.b2999a2d.png";